/**
 * Company stage strategy module index
 * 
 * This file exports all the components and functions from the company stage strategy modules.
 */

import { createCompanyStageStrategy } from './strategy';
import { CompanyStageOptions } from './components';
import { COMPANY_STAGES, COMPANY_STAGE_CATEGORIES } from './constants';
import { generateCompanyStageData } from './utils';

// Create and export the company stage strategy
const companyStageStrategy = createCompanyStageStrategy();

// Export the components and utility functions
export { 
  CompanyStageOptions,
  COMPANY_STAGES,
  COMPANY_STAGE_CATEGORIES,
  generateCompanyStageData
};

// Export the strategy as default
export default companyStageStrategy;
